module.exports = __webpack_public_path__ + "static/crowd_closeup-ba4ead8ea63012fa6dcb3922f5e0013c.jpg";